import { createContext, useState, useEffect } from 'react';
import axios from 'axios';
export const IcheerContext = createContext(null);

const AppContext = ({ children }) => {
  const [isSuperAdminLoggedIn, setSuperIsAdminLoggedIn] = useState(false);//Team 
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);//Team 
  const [team, setTeam] = useState({});
  const [websiteDetails, setWebsiteDetails] = useState({});
  const [host, setHost] = useState("https://icheerteams.com/api/");



  //https://icheerteams.com/api/

  useEffect(() => {
    const fetchUserStatus = async () => {
      let status = localStorage.getItem('isAdminLoggedIn');
      if (status === "true") {
        setIsAdminLoggedIn(true);
        fetchTeamInfo();
      }
    };

    fetchUserStatus();
    getWebsiteDetails();
  }, []);


  const fetchTeamInfo = async () => {
    const email = localStorage.getItem('userEmail');

    setIsAdminLoggedIn(true);

    if (email) {
      try {
        const res = await axios.get(`${host}team/by-email`, {
          params: { email }
        });
        setTeam(res.data);  // Save team in context
      } catch (error) {
        console.error("Error fetching team by email:", error);
      }

    }
  }

  const getWebsiteDetails = async () => {
    try {
      const response = await fetch(`${host}website/details`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to fetch website details');
      }

      const data = await response.json();
      setWebsiteDetails(data);
    } catch (error) {
    }
  }


  return (
    <IcheerContext.Provider
      value={{
        isAdminLoggedIn,
        setIsAdminLoggedIn,
        host,
        team,
        isSuperAdminLoggedIn,
        setSuperIsAdminLoggedIn,
        fetchTeamInfo,
        websiteDetails
      }}
    >
      {children}
    </IcheerContext.Provider>
  );
};

export default AppContext;
